<div fxLayout="column" fxLayoutGap="36px" fxLayoutGap.lt-md="36px">
    <label class="custom-file-upload color-dark-blue">
        <input type="file" style="display: none;" (change)="fileChangeEvent($event)" />
        <div fxLayoutAlign="center center">
            <mat-icon style="width: 45px">cloud_upload</mat-icon>
            <span>{{ 'ImageUpload.PhotoSelect' | translate }}</span>
        </div>
    </label>
    <div *ngIf="imageState == 'notConfirmed'" style="color: red;">
        {{'ImageUpload.noValidImageError' | translate}}
    </div>
    <div class="row" *ngIf="imageChangedEvent">
        <div class="text-center col-md-8">
            <div *ngIf="imageState == 'waitingForConfirmation' || imageState == 'confirmed'"
                style="position: relative;">
                <div *ngIf="imageState == 'waitingForConfirmation'" class="image-spinner-overlay"
                    fxLayoutAlign="center center">
                    <mat-progress-spinner diameter=50 mode="indeterminate" color="accent">
                    </mat-progress-spinner>
                </div>
                <img [style.opacity]="imageState == 'waitingForConfirmation' ? '0.7' : ''"
                    alt="positive picture example" [src]="sessionService.croppedImage" style="width: 100%;" />
            </div>
            <label *ngIf="imageState == 'confirmed'" class="custom-file-upload color-dark-blue w-100"
                (click)="changeSection()">
                <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="6px">
                    <mat-icon>edit</mat-icon>
                    <div>{{'ImageUpload.changeSection' | translate}}</div>
                </div>
            </label>
            <ng-container *ngIf="imageState == 'uploaded'">
                <image-cropper style="padding: 0;" [imageChangedEvent]="imageChangedEvent" [maintainAspectRatio]="true"
                    [aspectRatio]="0.78/1" format="png" (imageCropped)="imageCropped($event)"
                    (imageLoaded)="imageLoaded()" (cropperReady)="cropperReady()"
                    (loadImageFailed)="loadImageFailed()"></image-cropper>
                <label class="custom-file-upload color-dark-blue w-100" (click)="confirmImage()">
                    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="6px">
                        <mat-icon>check</mat-icon>
                        <div>{{'ImageUpload.confirmSection' | translate}}</div>
                    </div>
                </label>
            </ng-container>
        </div>
    </div>
</div>